import { IItem } from "./IItem";

export interface IIsValueUpdatedSpecifiable {
  isValueUpdated(oldItem: IItem): boolean;
}

export function instanceOfIIsValueUpdatedSpecifiable(instance: any): instance is IIsValueUpdatedSpecifiable {
  return instance
      && (instance.isValueUpdated !== undefined);
}
